/* eslint-disable @typescript-eslint/ban-ts-comment */

/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"
import * as Apollo from "@apollo/client"

import * as Types from "../../../shared/types/__generated__/graphql"
import { RoomChildrenFragmentDoc, RoomFragmentDoc } from "./fragments.generated"

type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }
const defaultOptions = {} as const
export type RoomQueryVariables = Exact<{
  id: string
}>

export type RoomQuery = {
  __typename: "Query"
  room?: {
    __typename: "Room"
    id: string
    label?: string | null
    number: string
    area?: number | null
    volume?: number | null
    utilization?: string | null
    height?: number | null
    personsNumber?: number | null
    airVolumePerArea?: number | null
    airVolumePerPerson?: number | null
    remark?: string | null
    sup?: number | null
    oda?: number | null
    eta?: number | null
    eha?: number | null
    tra?: number | null
    rca?: number | null
    ida?: number | null
    sec?: number | null
    soundPressureLevel?: number | null
    position: number
    createdAt: string
    updatedAt: string
    hasClarificationRequest?: boolean | null
    children?: Array<{
      __typename: "ProductPosition"
      id: string
      label?: string | null
      variantKey: string
      configurationKey?: string | null
      remark?: string | null
      quantity: number
      position: number
      displayPosition?: string | null
      isAlternative?: boolean | null
      price?: number | null
      priceGroup?: string | null
      hasClarificationRequest?: boolean | null
      references?: Array<{
        __typename: "ProductPositionInstallationReference"
        id: string
        title?: string | null
        permalink: string
        position: number
      }> | null
      addons?: Array<{
        __typename: "ProductPositionAddon"
        id: string
        variantKey: string
        parentProductType: string
      }> | null
      dimensioning?: {
        __typename: "ExternalDimensioningResult"
        transactionId: string
        environmentalVars?: Array<any> | null
        variantKeyData?: any
        dllVersion?: string | null
        language?: string | null
        technicalData?: Array<
          | {
              __typename: "ExternalDimensioningTechnicalDataDllVersion"
              dllVersion: string
            }
          | {
              __typename: "ExternalDimensioningTechnicalDataTable"
              header?: Array<string> | null
              content?: any
              summary?: string | null
              type?: string | null
            }
        > | null
        technicalInput?: Array<{
          __typename: "ExternalDimensioningTechnicalInput"
          name: string
          label?: string | null
          unit?: string | null
          value?: any
          userSelected: boolean
        }> | null
        supplementaryText?: Array<{
          __typename: "ExternalDimensioningSupplementaryText"
          text: string
        }> | null
        transferData?: {
          __typename: "ExternalDimensioningTransferData"
          origin?: string | null
        } | null
      } | null
    }> | null
  } | null
}

export const RoomDocument = gql`
  query Room($id: ID!) {
    room(id: $id)
      @rest(
        type: "Room"
        endpoint: "room"
        path: "/project-list/rooms/{args.id}?include=subtree"
      ) {
      ...Room
      ...RoomChildren
    }
  }
  ${RoomFragmentDoc}
  ${RoomChildrenFragmentDoc}
`

/**
 * __useRoomQuery__
 *
 * To run a query within a React component, call `useRoomQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoomQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoomQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRoomQuery(
  baseOptions: Apollo.QueryHookOptions<RoomQuery, RoomQueryVariables> &
    ({ variables: RoomQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<RoomQuery, RoomQueryVariables>(RoomDocument, options)
}
export function useRoomLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<RoomQuery, RoomQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<RoomQuery, RoomQueryVariables>(
    RoomDocument,
    options
  )
}
// @ts-ignore
export function useRoomSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<RoomQuery, RoomQueryVariables>
): Apollo.UseSuspenseQueryResult<RoomQuery, RoomQueryVariables>
export function useRoomSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<RoomQuery, RoomQueryVariables>
): Apollo.UseSuspenseQueryResult<RoomQuery | undefined, RoomQueryVariables>
export function useRoomSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<RoomQuery, RoomQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<RoomQuery, RoomQueryVariables>(
    RoomDocument,
    options
  )
}
export type RoomQueryHookResult = ReturnType<typeof useRoomQuery>
export type RoomLazyQueryHookResult = ReturnType<typeof useRoomLazyQuery>
export type RoomSuspenseQueryHookResult = ReturnType<
  typeof useRoomSuspenseQuery
>
export type RoomQueryResult = Apollo.QueryResult<RoomQuery, RoomQueryVariables>
